//****************************************************************************//
//* Scripts
//****************************************************************************//

jQuery(document).ready(function($) {

	/**
	* Initiate independent scripts
	*/
	$( 'body' ).addClass( 'page-loaded' );										// Apply class to body onload
	fnNavigationPrimary()														// Header navigation
	$( 'section.testimonials' ).each( fnTestimonialCarousel );					// Testimonials carousel
	$( 'section.image-tabs' ).each( fnImageTabs );								// Imade Tabs
	$( 'section.posts-carousel' ).each( fnPostsCarousel );						// Posts carousel
	$( 'section.work-carousel' ).each( fnWorkCarousel );						// Work carousel
	$( 'section.carousel' ).each( fnCarousel );									// Insights carousel
	$( 'body' ).on( 'click', '.popup', fnPopup );								// Links with .popup class open in a new tab/window
	fnImgLazyLoading(); 														// Image lazy loading
	fnScrollToID(); 															// Smooth anchor links
	fnDropdownStyling();														// Dropkick.js - Style `select` elements

});


// END OF DOCUMENT
